import index from "./CatalogView";
export default index;